import { Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import AuthLayout from './layouts/AuthLayout';
import DashboardLayout from './layouts/DashboardLayout';
import { LandingPage, LoginPage, RegisterPage, DashboardPage, NotFoundPage, StaffPage, SettingsPage, ForgotPasswordPage, ResetPasswordPage } from './pages';
import KnowledgePage from './pages/KnowledgePage';
import TeamChatPage from './pages/TeamChatPage';
import CustomersPage from './pages/CustomersPage';
import AnalyticsPage from './pages/AnalyticsPage';
import ClerkOpsPage from './pages/ClerkOpsPage';
import { PrivacyPage, TermsPage } from './pages/LegalPages';
import ForcePasswordChange from './features/auth/components/ForcePasswordChange';
import PWAUpdatePrompt from './components/PWAUpdatePrompt';
import { PartnerTheme } from './components/PartnerTheme';
import { IncomingCallToast, InCallPanel, AiEscalationToast, SipSoftphone } from './features/voice';
import { useVoiceSocketBridge, useTwilioDeviceBootstrap } from './lib/websocket';

function App() {
  // Subscribe to call:incoming / call:answered events globally.
  useVoiceSocketBridge();
  // Optionally connect the Twilio Voice SDK Device when the store is on the
  // twilio transport and the user is available for calls. No-op for webrtc.
  useTwilioDeviceBootstrap();

  return (
    <>
      <PartnerTheme />
      <PWAUpdatePrompt />
      <IncomingCallToast />
      <AiEscalationToast />
      <InCallPanel />
      <SipSoftphone />
      <Routes>
        {/* Landing Page (public) */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />

        {/* Auth Routes */}
        <Route element={<AuthLayout />}>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
        </Route>

        {/* Force password change (standalone, no dashboard layout) */}
        <Route path="/change-password" element={<ForcePasswordChange />} />

        {/* Dashboard Routes */}
        <Route element={<DashboardLayout />}>
          <Route path="/dashboard" element={<DashboardPage />} />

          {/* Each conversation's own link: email alerts, AI-escalation toast, Clerk facts */}
          <Route path="/conversations/:sessionId" element={<DashboardPage />} />

          {/* Team group chat (staff + AI) */}
          <Route path="/team-chat" element={<TeamChatPage />} />

          {/* Staff Management */}
          <Route path="/staff" element={<StaffPage />} />

          <Route path="/analytics" element={<AnalyticsPage />} />
          <Route path="/clerk-ops" element={<ClerkOpsPage />} />
          <Route path="/customers" element={<CustomersPage />} />
          <Route path="/knowledge" element={<KnowledgePage />} />
          <Route path="/settings" element={<SettingsPage />} />
        </Route>

        {/* 404 */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>

      {/* Toast Notifications */}
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#FFFFFF',
            color: '#0F1A33',
            border: '1px solid rgba(15,26,51,.10)',
            boxShadow: '0 8px 24px rgba(15,26,51,.12)',
          },
          success: {
            duration: 3000,
            iconTheme: {
              primary: '#3E8E24',
              secondary: '#fff',
            },
          },
          error: {
            duration: 5000,
            iconTheme: {
              primary: '#E5484D',
              secondary: '#fff',
            },
          },
        }}
      />
    </>
  );
}

export default App;
